/**
 * This class represents a pricing phase, describing how a user pays at a point in time.
 */
export class ProductPricingPhase {
    constructor(price, billingPeriod, billingCycleCount, recurrenceMode, type, isTrial, isIntro, isBasePlan) {
        this.price = price;
        this.billingPeriod = billingPeriod;
        this.billingCycleCount = billingCycleCount;
        this.recurrenceMode = recurrenceMode;
        this.type = type;
        this.isTrial = isTrial;
        this.isIntro = isIntro;
        this.isBasePlan = isBasePlan;
    }
}
//# sourceMappingURL=ProductPricingPhase.js.map